import { styled, Typography } from '@mui/material';

export const FONT_FAMILY = 'Open Sans, sans-serif';

export const BaseText = styled(Typography)({
  fontFamily: FONT_FAMILY,
});

export const SmallText = styled(BaseText)({
  fontSize: 12,
  fontWeight: 400,
});

export const LabelText = styled(BaseText)(({ theme }) => ({
  fontSize: 10,
  fontWeight: 400,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
}));

export const ListText = styled('span')(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  color: theme.palette.text.primary,
  letterSpacing: 0.4,
  lineHeight: '16px',
  fontFamily: FONT_FAMILY,
}));
